import { customElement, state, property } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { consume } from '@lit/context'
import { productTileProductContext } from 'components/discovery/product/tile-parts/tile-product-context.js'
import { InternalProduct, ProductModel } from 'components/discovery/product/tile-parts/tile-parts-typing.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { partsStyle } from 'components/discovery/product/tile-parts/tile-parts.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { HiddenFieldsMixin } from 'components/shared/hidden-fields/hidden-fields-mixin.js'

export const tileCodeHiddenFields = ['label'] as const

@customElement('csc-product-tile-product-code')
export class CSCProductTileProductCode extends HiddenFieldsMixin(LitElement, tileCodeHiddenFields) {
  static override styles: CSSResultGroup = [hostStyle, partsStyle]

  @state()
  private legacyHideText = false

  /** @deprecated Use `hidden-fields="label"` instead. */
  @property({ type: Boolean, attribute: 'hide-text' })
  set hideText(value: boolean) {
    console.warn('<csc-product-tile-product-code> "hide-text" is deprecated, use hidden-fields="label" instead.')
    this.legacyHideText = value
  }

  get hideText() {
    return this.legacyHideText || this.isHidden('label')
  }

  @consume({ context: productTileProductContext })
  @state()
  product: InternalProduct = new ProductModel().parseToInternal()

  override render() {
    return html`
      <cse-text class="product-code" variant="body-s">
        ${!this.hideText ? t('product_code', { ns: 'csc-product-tile', default: 'code: ' }) : nothing}
        ${this.product.code}
      </cse-text>
    `
  }
}
